import { Autocomplete, Button, Grid, TextField } from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import GlobalDialogContent from '../GlobalDialogContent';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../redux/store';
import { closeDialog } from '../../../redux/reducer/dialogSlice';
import { RoleListService, UpdateUserRoleService } from '../../../utils/services/registration/donor-registration.service';
import { showSnackbar } from '../../../redux/reducer/snackbarSlice';
import { setModuleRefresh } from '../../../redux/reducer/registration/RefreshSlice';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CheckCircleOutlined } from '@mui/icons-material';

export default function AddRoletoUser() {
    const dispatch = useDispatch();
    const { payload } = useSelector((state: RootState) => state.dialog);

    const [searchParams] = useSearchParams();

    const type = searchParams.get("type");
    const [roleList, setRoleList] = useState<any[]>([]);

    const fetchRoles = async () => {
        const payload = {
            limit: 99,
            offset: 0,
        };
        const { data, code } = await RoleListService(payload);
        if (code === 200 && data) {
            const GovRoles = data?.data?.filter(
                (item: any) => item.user_type === "cmrf_department" || item.user_type === "csr_cell" || item.user_type === "government_user"
            );
            const DonorRoles = data?.data?.filter(
                (item: any) => item.user_type === "donor"
            );
            const AgnecyRoles = data?.data?.filter(
                (item: any) => item.user_type === "implementing_agency"
            );
            const HospitalRoles = data?.data?.filter(
                (item: any) => item.user_type === "hospital"
            );
            if (type === 'government_user') {
                setRoleList(GovRoles);
            } else if (type === 'donor') {
                setRoleList(DonorRoles);
            } else if (type === 'implementing_agency') {
                setRoleList(AgnecyRoles);
            }
            else if (type === 'hospital') {
                setRoleList(HospitalRoles);

            }
            else {
                setRoleList([]);
            }
        }
    };

    useEffect(() => {
        fetchRoles();
    }, []);

    return (
        <GlobalDialogContent
            dialogBody={
                <Formik
                    initialValues={{ role: '' }}
                    validationSchema={Yup.object({
                        role: Yup.string().trim().required("Please Select Role "),
                    })}
                    onSubmit={async (values, { setSubmitting }) => {
                        const submitPayload = {
                            request_id: payload?.id,
                            user_type: type,
                            role_id: values.role
                        };
                        const { code, message } = await UpdateUserRoleService(submitPayload);
                        if (code === 200) {
                            dispatch(closeDialog());
                            dispatch(setModuleRefresh({ moduleName: 'user_details', refresh: true }));
                            dispatch(showSnackbar({ type: 'success', message: message || 'Status Updated Successfully' }));
                        } else {
                            dispatch(showSnackbar({ type: 'error', message: message || 'Something Went Wrong ,Please try again' }));
                        }

                        setSubmitting(false);
                    }}
                >
                    {({ errors, touched, setFieldValue, values }) => (
                        <Form id="user-role-form">
                            <Grid container columnSpacing={2}>
                                <Grid item xs={12} lg={6} md={6} sx={{ mt: 2 }}>
                                    <Autocomplete
                                        size="small"
                                        options={roleList}
                                        value={roleList.find((r) => r.id === values.role) || null}
                                        getOptionLabel={(option: any) => option?.name || ''}
                                        onChange={(event, newValue) => {
                                            setFieldValue('role', newValue?.id || '');
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Select Role"
                                                variant="outlined"
                                                error={touched.role && Boolean(errors.role)}
                                                helperText={touched.role && errors.role}
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            }
            dialogFooter={
                <Button startIcon={<CheckCircleOutlined />} type="submit" variant="contained" color='success' form="user-role-form" >
                    Assign
                </Button>
            }
        />
    );
}
